import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export default function Logo({ className = "", onClick }) {
  const { content } = useContent();
  const brand = content?.brand || {};
  const logoUrl = brand.logoUrl;
  const name = brand.companyName || "Elevate Analytics Academy";

  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="site-logo"
      className={`group flex items-center gap-3 ${className}`}
    >
      {logoUrl ? (
        <span className="flex items-center justify-center rounded-md bg-white p-1.5 shadow-sm transition-transform duration-300 group-hover:scale-105">
          <img src={logoUrl} alt={name} className="h-20 w-20 object-contain" />
        </span>
      ) : (
        <span className="relative flex h-8 w-8 items-center justify-center border border-white/20">
          <span className="h-2.5 w-2.5 bg-brand-blue transition-colors duration-300 group-hover:bg-brand-magenta" />
          <span className="absolute -right-1 -top-1 h-1.5 w-1.5 bg-brand-magenta" />
        </span>
      )}
      <span className="hidden font-display text-base font-semibold leading-tight tracking-normal text-white sm:block">
        {name}
      </span>
    </Link>
  );
}
